/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S3_P2Inputs */

const en_guide_what_is_json_s3_p2 = /** @type {(inputs: Guide_What_Is_Json_S3_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON's native compatibility with JavaScript gave it an early advantage in web development, but its true strength lies in universal support. Whether you're working in Python, Java, Go, Rust, or any other modern language, JSON parsing libraries are readily available and well-optimized.`)
};

const ko_guide_what_is_json_s3_p2 = /** @type {(inputs: Guide_What_Is_Json_S3_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON의 JavaScript 네이티브 호환성은 웹 개발에서 초기 이점을 제공했지만, 진정한 강점은 범용적인 지원에 있습니다. Python, Java, Go, Rust 또는 기타 현대 언어로 작업하든 JSON 파싱 라이브러리는 쉽게 사용할 수 있고 잘 최적화되어 있습니다.`)
};

const ja_guide_what_is_json_s3_p2 = /** @type {(inputs: Guide_What_Is_Json_S3_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JavaScriptとのネイティブ互換性がWeb開発での初期の優位性を与えましたが、JSONの真の強みは普遍的なサポートにあります。Python、Java、Go、Rustなど、あらゆる現代的な言語でJSONパースライブラリが利用可能で、十分に最適化されています。`)
};

/**
* | output |
* | --- |
* | "JSON's native compatibility with JavaScript gave it an early advantage in web development, but its true strength lies in universal support. Whether you're wo..." |
*
* @param {Guide_What_Is_Json_S3_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s3_p2 = /** @type {((inputs?: Guide_What_Is_Json_S3_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S3_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s3_p2(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s3_p2(inputs)
	return ja_guide_what_is_json_s3_p2(inputs)
});